import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const refundApi = `${process.env.NEXT_PUBLIC_APP_API_URL}/api/refund/admin`;

const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getAdminRefundListThunk = createAsyncThunk(
    "admin-refund-list",
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${refundApi}/list`, { params, ...authHeader(token) });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: "Failed to fetch refunds" });
        }
    }
);

export const getAdminRefundDetailsThunk = createAsyncThunk(
    "admin-refund-details",
    async ({ token, refundId }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${refundApi}/details/${refundId}`, authHeader(token));
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: "Failed to fetch refund details" });
        }
    }
);

export const approveRefundThunk = createAsyncThunk(
    "admin-refund-approve",
    async ({ token, refundId }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${refundApi}/approve/${refundId}`, {}, authHeader(token));
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: "Failed to approve refund" });
        }
    }
);

export const rejectRefundThunk = createAsyncThunk(
    "admin-refund-reject",
    async ({ token, refundId, adminReason }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${refundApi}/reject/${refundId}`,
                { adminReason },
                authHeader(token)
            );
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: "Failed to reject refund" });
        }
    }
);

export const retryRefundThunk = createAsyncThunk(
    "admin-refund-retry",
    async ({ token, refundId }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${refundApi}/retry/${refundId}`, {}, authHeader(token));
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: "Failed to retry refund" });
        }
    }
);
